import styled from "styled-components";

import { colors, typography } from "src/assets/styles/settings";

export const StepContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  width: 100%;
`;

export const StepItem = styled.div`
  display: inline-block;
  margin-right: 8px;
  position: relative;
  width: 100%;

  &.is-disabled {
    cursor: not-allowed;
  }

  &:last-child {
    margin-right: 0;
  }

  & > a {
    text-decoration: none;
  }
`;

export const StepBar = styled.div`
  background-color: ${colors.light_grey};
  border-radius: 8px;
  height: 5px;

  .is-done > &,
  .is-done > a > & {
    background-color: ${colors.jade};
  }

  .is-done > a:hover > & {
    background-color: ${colors.pine};
  }
`;

export const StepLabel = styled.div`
  color: ${colors.dark_grey};
  font-size: ${typography.font_size.small};
  font-weight: ${typography.font_weight.bold};
  margin-bottom: 4px;
  position: relative;
  text-align: left;

  .is-done > &,
  .is-done > a > & {
    color: ${colors.black_bekko};
  }

  .is-done > a:hover > & {
    color: ${colors.dark_smoke};
  }
`;

export const NewStepItem = styled.div`
  &.is-disabled {
    cursor: not-allowed;
  }

  &:last-child {
    margin-right: 0;
  }

  & > a {
    text-decoration: none;
    display: flex;
    gap: 0.5rem;
    color: ${colors.black_bekko};
    align-items: center;
    flex: 1;
    font-weight: normal;

    &:hover {
      & > div:last-child {
        background-color: ${colors.neutral_border};
      }
    }
  }
`;

export const BulletNumber = styled.div`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  aspect-ratio: 1;

  background: ${colors.main_background};
  border: 2px solid ${colors.main_background};
  text-align: center;
  font-weight: bold;

  font-size: ${typography.font_size.small};
`;

export const HorizontalLine = styled.div<{ isSpreaded: boolean }>`
  height: 2px;
  background-color: ${colors.neutral_border};
  width: ${({ isSpreaded }) => (isSpreaded ? "100%" : "unset")};
  min-width: 24px;
  border-radius: 8px;
`;
